import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { resetFilters } from "../redux/notificationsSagas";
import { MainModal } from "../../../../components/modal/MainModal";

export const Preview = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();

  const {
    selected: { message }
  } = useSelector((state) => state.notifications);

  let close = () => {
    dispatch(resetFilters());
    onClose();
  };

  return (
    <MainModal
      isOpen={isOpen}
      containerClassName="preview popup__notification"
      parentSelector=".notifications"
      width="1350px"
      height="auto"
      primaryButtonText="I acknowledge this message"
      primaryBtnHandler={close}
      onClose={close}
      swapFooter
    >
      <div dangerouslySetInnerHTML={{ __html: message }} />
    </MainModal>
  );
};
